/**
 * Keeps only the latest of overlapping async runs (the console's screen renders): each run
 * takes a ticket, and a result whose ticket is no longer the latest is stale and must be
 * dropped. A slow first «Resumen» load can no longer overwrite the screen the person clicked.
 */
export function latestOnly() {
  let seq = 0;
  return {
    /** Starts a run; the returned check says whether it is still the latest one. */
    begin(): () => boolean {
      const mine = ++seq;
      return () => mine === seq;
    },
  };
}
